/*export const BUTTON_SIZE = 36;
export const ITEM_SIZE = 56;*/
export const BUTTON_SIZE = 57;
export const ITEM_SIZE = 78;
export const CONTAINER_SIZE = 130;
export const RADIUS = CONTAINER_SIZE / 2;

export const WHITE = "#ffffff";
export const PRIMARY = "#2ea09b";
export const PRIMARY_2 = "#268e89";
export const BORDER = "#dadada";
export const TEXT = "#656565";


export const MAX_NAME_SIZE = 50;
export const MAX_NUMBER_SIZE = 4;
export const MAX_DESCRIPTION_SIZE = 255;